module.exports = __webpack_public_path__ + "img/云稼分销-太阳码.4a97464e.jpg";